var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Loading",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.2 306.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .loading-cls-1 {\n        fill: aqua;\n      }\n\n      .loading-cls-2 {\n        fill: #364984;\n      }\n\n      .loading-cls-3 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loading-1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "loading-cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "loading-cls-2",
    cx: 153.2,
    cy: 156.62,
    r: 150
  })), /*#__PURE__*/React.createElement("path", {
    className: "loading-cls-1",
    d: "m293.2,156.62c.4-27.64-7.46-55.27-22.55-78.47C222.01,2.56,114.86-8.67,50.67,54.09-28.85,131.99,4.17,265.72,109.83,299.58c14,4.48,28.66,6.74,43.37,7.04-22.16.24-44.36-4.29-64.54-13.54C-16.5,244.58-30.99,102.06,60.68,31.88,139.04-28.18,253.93-.1,297,88.61c10.38,21.1,15.82,44.52,16.2,68.02.14,5.52-4.22,10.11-9.75,10.25-5.7.16-10.4-4.55-10.25-10.25h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingWheel);
export default __webpack_public_path__ + "static/media/LoadingWheel.92b0d726ce80678a0cf04f94f67851e9.svg";
export { ForwardRef as ReactComponent };